@use '@design/bapf-pattern-library/source/sass/globals' as *;
@use '@design/bapf-pattern-library/source/sass/vendor/bootstrap';

@use '@design/bapf-pattern-library/source/sass/patterns/alert';

#maintenance-info-container {
  background-color: $color-blue-light;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  box-shadow: 0 0 30px -10px black;
  z-index: 1049;

  padding-left: 48px;
  &::after {
    top: 25px;
    left: 12px;
  }

}


@media (min-width: map-get($grid-breakpoints, 'md')) {
  #maintenance-info-container {
    max-width: 600px;
    margin-bottom: 80px;
    padding-left: 24px;
    &::after {
      top: 12px;
      left: -9px;
    }
  }
}

